export const BRANDS = [
  'Kyoto Pearl', 'Aura', 'Emojem', 'Wolfe & Jackson',
  'The Pearl Co', 'Jade&Stone', 'Ashley&Taylor', 'Encharmed',
  'Voyager', 'Cath Kidston', 'Badgley Mischka', 'Made by Mitchell',
  'Beauty Works', 'StylPro', 'GlowHub'
]

export const CUSTOMER_TYPES = [
  'Off-Price Retail',
  'Standard Wholesale',
  'Travel Retail',
  'D2C',
  'Casino',
  'Domestic Retail'
]

export const PRODUCT_TYPES = ['Watch', 'Jewellery', 'Accessory', 'Beauty']

export const GENDERS = ['Male', 'Female', 'Unisex']

export const ROLES = {
  admin: {
    label: 'Admin',
    canEdit: true,
    canDelete: true,
    canImport: true,
    canExport: true,
    canManageTeam: true,
    canEditPricing: true,
  },
  editor: {
    label: 'Editor',
    canEdit: true,
    canDelete: false,
    canImport: true,
    canExport: true,
    canManageTeam: false,
    canEditPricing: true,
  },
  sales: {
    label: 'Sales',
    canEdit: false,
    canDelete: false,
    canImport: false,
    canExport: true,
    canManageTeam: false,
    canEditPricing: false,
  },
  viewer: {
    label: 'Viewer',
    canEdit: false,
    canDelete: false,
    canImport: false,
    canExport: false,
    canManageTeam: false,
    canEditPricing: false,
  },
}

export const CURRENCIES = ['GBP', 'USD', 'EUR']

export const EMPTY_PRODUCT = {
  sku: '',
  supplier_code: '',
  brand: '',
  ean_code: '',
  hts_code: '',
  trex: '',
  factory_moq: '',
  msds_sheet: '',
  user_manual: '',
  product_type: 'Watch',
  gender: 'Male',
  country_of_origin: 'China',
  factory_sku: '',
  production_time_weeks: 6,
  reference_image: '',
  packshot_image: '',
  model_image: '',
  case_size_mm: '',
  movement_model: '',
  battery: '',
  size_mm: '',
  product_weight: '',
  weight_including_packaging: '',
  packaging_image: '',
  packaging_sku: '',
  packaging_dimensions: '',
  packaging_instructions: '',
  packaging_eco_friendly: false,
  qty_per_case: '',
  case_size_cm: '',
  specification: '',
  base_metal: '',
  plating_type: '',
  stone_gemstone: '',
  description_en: '',
  description_de: '',
  description_es: '',
  description_fr: '',
  factory_cost: '',
  packaging_cost: 1.4,
  freight: 0.3,
  stock_uk: 0,
  stock_de: 0,
  avg_weekly_sales: 2,
}
